var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.8,
    height: 23.111,
    viewBox: "1105.68 25 23.8 23.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1633",
    transform: "translate(1105.68 25)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.665 23.11H4.135A4.14 4.14 0 0 1 0 18.976V5.559a4.14 4.14 0 0 1 4.135-4.135h15.53A4.14 4.14 0 0 1 23.8 5.559v13.417a4.138 4.138 0 0 1-4.135 4.134M4.135 3.078a2.484 2.484 0 0 0-2.481 2.48v13.418a2.484 2.484 0 0 0 2.48 2.48h15.531a2.484 2.484 0 0 0 2.481-2.48V5.559a2.484 2.484 0 0 0-2.48-2.481H4.134Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.873 6.662h22.054v1.654H.873V6.662z",
    fillRule: "evenodd",
    "data-name": "Rectangle 1432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.634 4.41a.827.827 0 0 1-.827-.826V.827a.827.827 0 0 1 1.654 0v2.757c0 .456-.37.827-.827.827",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 4.41a.827.827 0 0 1-.827-.826V.827a.827.827 0 0 1 1.654 0v2.757c0 .456-.37.827-.827.827",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.166 4.41a.827.827 0 0 1-.827-.826V.827a.827.827 0 0 1 1.654 0v2.757c0 .456-.37.827-.827.827",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97 12.676H3.91a1.429 1.429 0 0 1 0-2.857h2.06a1.429 1.429 0 0 1 0 2.856m-2.06-1.901a.475.475 0 0 0 0 .947h2.06a.473.473 0 1 0 0-.947H3.91Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.93 12.676h-2.059a1.43 1.43 0 0 1-1.429-1.428c0-.787.642-1.429 1.43-1.429h2.059a1.429 1.429 0 0 1 0 2.856m-2.06-1.901a.475.475 0 0 0 0 .947h2.06a.473.473 0 1 0 0-.947h-2.06Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.892 12.676h-2.06a1.43 1.43 0 0 1-1.428-1.428c0-.787.642-1.429 1.429-1.429h2.059c.787 0 1.429.642 1.429 1.43a1.43 1.43 0 0 1-1.43 1.427m-2.058-1.902a.475.475 0 0 0 0 .947h2.059a.474.474 0 1 0 0-.947h-2.06Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97 16.43H3.91a1.43 1.43 0 0 1-1.43-1.429c0-.787.641-1.429 1.43-1.429h2.06a1.43 1.43 0 0 1 0 2.858m-2.06-1.904a.476.476 0 0 0 0 .95h2.06a.474.474 0 0 0 0-.95H3.91Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.93 16.43h-2.059a1.432 1.432 0 0 1-1.429-1.429c0-.787.642-1.429 1.43-1.429h2.059a1.43 1.43 0 0 1 0 2.858m-2.06-1.904a.476.476 0 0 0 0 .95h2.06a.474.474 0 0 0 0-.95h-2.06Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.892 16.43h-2.06a1.431 1.431 0 0 1-1.428-1.429c0-.787.642-1.429 1.429-1.429h2.059c.787 0 1.429.642 1.429 1.43 0 .786-.642 1.428-1.43 1.428m-2.058-1.904a.476.476 0 0 0 0 .95h2.059a.476.476 0 0 0 0-.95h-2.06Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97 20.181H3.91a1.429 1.429 0 0 1 0-2.856h2.06a1.429 1.429 0 0 1 0 2.856M3.91 18.28a.475.475 0 0 0 0 .948h2.06a.473.473 0 1 0 0-.948H3.91Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.93 20.181h-2.059a1.43 1.43 0 0 1-1.429-1.427c0-.787.642-1.43 1.43-1.43h2.059a1.429 1.429 0 0 1 0 2.856m-2.06-1.9a.475.475 0 0 0 0 .947h2.06a.473.473 0 1 0 0-.948h-2.06Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.892 20.181h-2.06a1.43 1.43 0 0 1-1.428-1.427c0-.787.642-1.43 1.429-1.43h2.059c.787 0 1.429.643 1.429 1.43a1.43 1.43 0 0 1-1.43 1.427m-2.058-1.902a.475.475 0 0 0 0 .948h2.059a.474.474 0 1 0 0-.948h-2.06Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6671"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h23.8v23.11H0V0z",
    "data-name": "Rectangle 1433"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b6b10d060e705ea3548406d100d95329.svg";
export { ForwardRef as ReactComponent };